import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import NewsletterForm from "@/components/NewsletterForm";
import { X, Bell } from "lucide-react";

const KEY = "nl_popup_seen_at";
const COOLDOWN_DAYS = 7;

export default function NewsletterPopup() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user?.is_demo) return;
    const last = Number(localStorage.getItem(KEY) || 0);
    if (last && Date.now() - last < COOLDOWN_DAYS * 864e5) return;

    let fired = false;
    const trigger = () => {
      if (fired) return;
      fired = true;
      localStorage.setItem(KEY, String(Date.now()));
      setShow(true);
    };
    const onInteract = () => { setTimeout(trigger, 100); };
    const t = setTimeout(trigger, 38000); // Fallback nach ~38s
    // ODER früher bei sichtbarer Interaktion (frühestens ~12s)
    const enable = setTimeout(() => {
      window.addEventListener("scroll", onInteract, { passive: true, once: true });
      window.addEventListener("pointerdown", onInteract, { once: true });
    }, 12000);
    return () => {
      clearTimeout(t); clearTimeout(enable);
      window.removeEventListener("scroll", onInteract);
      window.removeEventListener("pointerdown", onInteract);
    };
  }, [user]);

  if (!user?.is_demo || !show) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[60] w-[calc(100%-2rem)] sm:w-[380px]" data-testid="newsletter-popup"
      style={{ animation: "fc-fade-up 0.4s ease-out" }}>
      <div className="bg-white rounded-2xl border border-fc-border shadow-2xl p-5 relative">
        <button onClick={() => setShow(false)} data-testid="newsletter-popup-close" aria-label="Schließen"
          className="absolute top-3 right-3 text-fc-ink/40 hover:text-fc-ink transition-colors"><X className="w-4 h-4" /></button>
        <div className="w-10 h-10 rounded-xl bg-fc-blue/10 flex items-center justify-center"><Bell className="w-5 h-5 text-fc-blue" /></div>
        <h3 className="mt-3 font-head font-bold text-lg text-fc-ink pr-6">Bei NEWZER auf dem Laufenden bleiben.</h3>
        <p className="mt-1 text-sm text-fc-ink/60">Neue Funktionen, Einblicke und Neuigkeiten rund um NEWZER – kompakt per E-Mail.</p>
        <div className="mt-4"><NewsletterForm source="demo" onDone={() => setTimeout(() => setShow(false), 2600)} /></div>
      </div>
    </div>
  );
}
